module.exports = __webpack_public_path__ + "img/monbaceco1.3ef5854c.png";